import { DEFAULT_PAGE_SIZE } from '@constants';
import { TDetailUserResponse, TSearchUserResponse } from '@models/user';
import { API_URL } from '@redux/rootConstant';
import { TAxiosResponse } from 'types';
import { TRegisUserReq, TSearchUserReq, TUpdateUserReq } from 'types/types';
import { axiosInstance } from './axiosInstance';

const userApi = {
  searchUserList: async (payload: TSearchUserReq) => {
    const page = payload.page ? payload.page : 1;
    const response: TAxiosResponse<TSearchUserResponse> =
      await axiosInstance.get(API_URL.USER.SEARCH, {
        params: {
          fullName: payload.fullName,
          username: payload.username,
          roleCode: payload.roleCode,
          companyId: payload.companyId,
          storeId: payload.storeId,
          page: page,
          pageSize: DEFAULT_PAGE_SIZE,
        },
      });
    return response;
  },
  getUserDetail: async (payload: string) => {
    const response: TAxiosResponse<TDetailUserResponse> =
      await axiosInstance.get(`${API_URL.USER.DETAIL}/${payload}`);
    return response;
  },

  regisUser: async (payload: TRegisUserReq) => {
    const response: TAxiosResponse<any[]> = await axiosInstance.post(
      API_URL.USER.DETAIL,
      {
        userName: payload.userName,
        fullName: payload.fullName,
        password: payload.password,
        roleCode: payload.roleCode,
        companyId: payload.companyId,
        storeId: payload.storeId,
        sectorId: payload.sectorId,
        processingCenterId: payload.processingCenterId,
        isValidationOnly: payload.isValidationOnly,
      }
    );
    return response;
  },

  updateUser: async (payload: TUpdateUserReq) => {
    const response: TAxiosResponse<any[]> = await axiosInstance.put(
      `${API_URL.USER.DETAIL}/${payload.id}`,
      {
        fullName: payload.fullName,
        password: payload.password,
        roleCode: payload.roleCode,
        companyId: payload.companyId,
        storeId: payload.storeId,
        sectorId: payload.sectorId,
        processingCenterId: payload.processingCenterId,
        isValidationOnly: payload.isValidationOnly,
      }
    );
    return response;
  },

  deleteUser: async (payload: string) => {
    const url = `${API_URL.USER.DETAIL}/${payload}`;
    const response: TAxiosResponse<any[]> = await axiosInstance.delete(url);
    return response;
  },
};

export { userApi };
